document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-new-collection-cards]').forEach(section => {
    const carousel = section.querySelector('[data-carousel]');
    const scrollbar = section.querySelector('[data-scrollbar]');
    const thumb = section.querySelector('[data-scrollbar-thumb]');
    if (!carousel || !scrollbar || !thumb) return;

    let cachedScrollWidth = 0;
    let cachedClientWidth = 0;
    let cachedTrackWidth = 0;
    let rafPending = false;

    // Only reads carousel.scrollLeft on scroll — no forced layout reads.
    // Stable sizes (scrollWidth, clientWidth, trackWidth) come from ResizeObserver below.
    const update = () => {
      if (cachedScrollWidth <= cachedClientWidth) return;
      const thumbWidth = (cachedClientWidth / cachedScrollWidth) * cachedTrackWidth;
      const thumbTranslate = (carousel.scrollLeft / (cachedScrollWidth - cachedClientWidth)) * (cachedTrackWidth - thumbWidth);
      section.style.setProperty('--thumb-width', thumbWidth + 'px');
      section.style.setProperty('--thumb-translate', thumbTranslate + 'px');
    };

    // ResizeObserver fires after layout — reads here are free (no forced reflow).
    // Also fires once on observe, replacing the old requestAnimationFrame(update) initial call.
    new ResizeObserver(() => {
      cachedScrollWidth = carousel.scrollWidth;
      cachedClientWidth = carousel.clientWidth;
      cachedTrackWidth = scrollbar.offsetWidth;
      update();
    }).observe(carousel);

    carousel.addEventListener('scroll', () => {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(() => {
        update();
        rafPending = false;
      });
    }, { passive: true });
  });
});
